export default __webpack_public_path__ + "static/media/1098.e7307815.png";